<template>
  <TableCell v-model:showingPopover="showingPopover" :tag popoverPadding="0px" >
    {{ tag.$convertedValueString(precision) }}
    <span v-html="convertedUnitHtml(tag.$unit())"></span>

    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>

    <template #PopoverContentDesktop>
      <div class="AnalogOutputStatusPopover">
        <div :style="headerStyle">
          <div style="flex-grow: 1; display: flex; align-items: center; gap: 15px;">
            <h3>
              {{ tag.name.value }}
            </h3>
            <span v-if="store.showAdvanced" style="font-family: 'Reddit Mono'; padding-top: 1px;">
              {{ controlChannelLabel(tag) }}
            </span>
          </div>
          <Button text severity="secondary" style="margin-right: -10px; color: gray; border: 0;" @click="showingPopover = false">
            <i class="pi pi-times"></i>
          </Button>
        </div>
        <TieredMenu class="AnalogOutputStatusPopover" :model="menuItems" style="border: 0;"></TieredMenu>
      </div>
    </template>
  </TableCell>
</template>

<script setup>
import { computed } from "vue";
import TableCell from "./TableCell.vue";
import store, { showingDesktopUi } from "./store.js";
import { controlChannelLabel, openHistory } from "./appUtility.js";
import { convertedUnitHtml } from "./units.js";

let props = defineProps([
  "tag",
  "precision",
  "showingPopover"
]);

let showingPopover = defineModel("showingPopover");

let headerStyle = computed(() => {
  return {
    padding: showingDesktopUi.value ? "15px" : "0",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: showingDesktopUi.value ? "-5px" : "15px"
  };
});

let menuItems = computed(() => [
  { 
    separator: true,
    visible: showingDesktopUi.value
  },
  { 
    label: "View history",
    command: () => openHistory(props.tag)
  }
]);
</script>

<style>
.AggregateStatusPopoverSimple .p-menuitem-content {
  padding: 3px;
  font-size: large;
}
</style>